import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { useI18n } from "../i18n/I18nProvider";
import { api } from "../lib/api";

/** /baja?u=&t= — the unsubscribe link in marketing emails. A click confirms (mail scanners only GET). */
export function UnsubscribePage() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const u = params.get("u") ?? "";
  const token = params.get("t") ?? "";
  const [state, setState] = useState<"idle" | "busy" | "done" | "error">(u && token ? "idle" : "error");

  const confirm = async () => {
    setState("busy");
    try {
      await api.unsubscribe(u, token);
      setState("done");
    } catch {
      setState("error");
    }
  };

  return (
    <section className="container section narrow">
      <h1>{t("unsubscribe.title")}</h1>
      {state === "done" ? (
        <p role="status">{t("unsubscribe.done")}</p>
      ) : state === "error" ? (
        <p className="field-error">{t("unsubscribe.invalid")}</p>
      ) : (
        <>
          <p>{t("unsubscribe.text")}</p>
          <button type="button" className="btn btn-primary" onClick={confirm} disabled={state === "busy"}>
            {t("unsubscribe.button")}
          </button>
        </>
      )}
      <p>
        <Link to="/">{t("notFound.back")}</Link>
      </p>
    </section>
  );
}
